<template>
  <v-btn
    v-permission="permissions"
    color="light"
    :disabled="disabled"
    :class="{ w100: $vuetify.breakpoint.lgAndDown }"
    x-small
    @click="$dialog.show(dialog, { item })"
  >
    <v-icon left>edit</v-icon> Редактировать
  </v-btn>
</template>

<script>
export default {
  name: 'edit-button',
  props: {
    permissions: {
      type: Array,
      default: () => [],
    },
    dialog: {
      type: String,
      default: () => '',
    },
    disabled: Boolean,
    item: Object,
  },
};
</script>

<style scoped>

</style>
